export default __webpack_public_path__ + "static/media/emoji.10626a10.svg";